// @ts-nocheck
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetPaymentMethod } from '../../store/HR/Payroll/PayrollSlice';
import { useTranslation } from 'react-i18next';

const useGetPaymentMethod = () => {
  const dispatch = useDispatch();

  const { i18n } = useTranslation();

  useEffect(() => {
    if (PaymentMethodList?.length === 0) {
      dispatch(GetPaymentMethod());
    }
  }, []);
  const { PaymentMethodList, loading, error } = useSelector(state => state.Payrolls);

  const optionsPaymentMethod = PaymentMethodList?.map(m => ({
    value: m.id,
    label: i18n.language === 'en' ? m.name : m.name2
  }));

  return { PaymentMethodList, loading, error, optionsPaymentMethod };
};

export default useGetPaymentMethod;
